import {
  Flex,
  IconArrowEndLine,
  IconArrowStartLine,
  IconButton,
  IconDownloadLine,
  Text,
} from "@instructure/ui";
import { t } from "i18next";
import downloadFile from "../../utils/Dom";

const CustomHeader = (state, previousDocument, nextDocument) => {
  if (!state.currentDocument || state.config?.header?.disableFileName) {
    return null;
  }

  const handleDownloadEvidence = () => {
    downloadFile(state.currentDocument.uri, state.currentDocument.fileName);
  };

  return (
    <Flex gap="small" padding="0 0 small 0" wrap="wrap">
      <Flex.Item>
        <Text>{state.currentDocument.fileName || ""}</Text>
      </Flex.Item>
      <Flex.Item shouldGrow>
        <IconButton
          size="small"
          onClick={handleDownloadEvidence}
          screenReaderLabel={t("juriedAssessment.downloadStudentEvidence")}
          renderIcon={IconDownloadLine}
        />
      </Flex.Item>
      {state.documents.length > 1 && (
        <Flex.Item>
          <Text>
            {t("evidence.evidence")} {state.currentFileNo + 1}{" "}
            {t("juriedAssessment.of")} {state.documents.length}
          </Text>
          <IconButton
            size="small"
            onClick={previousDocument}
            screenReaderLabel={t("documentViewer.previousDocument")}
            renderIcon={IconArrowStartLine}
            margin="0 small"
            disabled={state.currentFileNo === 0}
          />
          <IconButton
            size="small"
            onClick={nextDocument}
            screenReaderLabel={t("documentViewer.nextDocument")}
            renderIcon={IconArrowEndLine}
            disabled={state.currentFileNo >= state.documents.length - 1}
          />
        </Flex.Item>
      )}
    </Flex>
  );
};

export default CustomHeader;
